<template>
  <div>
    <div class="text-center bold banner">
      <p class="banner-title mb-0">CONTÁCTANOS</p>
    </div>
    <b-container>
      <b-row class="">
        <b-col cols="12" md="6">
          <Form/>
        </b-col>
        <b-col cols="12" md="6">
          <Contact/>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>
<script>
import Form from '../components/Form';
import Contact from '../components/Contact';
export default {
  components: { Form, Contact},
    metaInfo: {
    title: "Servicios Aduanales Integrales | Yonekawa y Asociados",
    meta: [
      { name: "Servicios", content: "Servicios" },
      { name: "Tramites", content: "COFEPRIS" },
    ],
  },
}
</script>
